<template>
    <Head :title="title">
        <slot />
    </Head>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';

const props = defineProps({
    title: String,
});
</script>
